import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";

export class AllActivePatients extends Component {
  constructor(props) {
    super(props);

   

    // const url = ''
    this.state = {
      visitid: "",
      DataLoaded: false,
      AntenatalLoaded: false,
      MedicalDisordersLoaded: false,
      ObstetricsDataLoaded: false,
      allModuleData: "",
      visible: "visible",
      // MLoaded: false,
    };
  }

  componentDidMount() {
    $("body").on("click", ".checkPatientDetails", function (e) {
      e.preventDefault();
      var id = $(this).attr("id");

      var patientName = $(this).text();
      localStorage.removeItem("patientVisitId");
      localStorage.setItem("patientVisitId", id);
      localStorage.removeItem("currentVisitName");
      localStorage.setItem("currentVisitName", patientName);
      window.location.href = "/patient/all/data";
    });
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),

      // 'visitid': localStorage.getItem('visitId')
    };
    axios
      .get(this.api_url+"reception/activevisits", { headers: headers })
      .then((res) => {
        const verified = res.data;
        //   console.log(verified)
        localStorage.removeItem("verifiedlength");
        localStorage.setItem("verifiedlength", verified.length);

        for (var i = 0; i < verified.length; i++) {
          // console.log(Object.keys(res.data)[i][Object.keys(res.data[Object.keys(res.data)[i]])])
          const headers2 = {
            "Content-Type": "application/json",
            token: localStorage.getItem("accessToken"),
            visitid: res.data[i]["visitid"],
          };
          //   console.log(res.data[i]['visitid'])
          var allNames = [];
          // console.log(headers2)
          axios
            .get(this.api_url+"reception/onepatient", { headers: headers2 })
            .then((resdata) => {
              //   const verified = res.data;
              // console.log(resdata.data[0])
              // allstring = resdata.data[0]['Name']

              var name = resdata.data[0]["Name"];
              // console.log(name)
              allNames.push(name);
              var div =
                '<tr><td><a class="btn btn-primary checkPatientDetails" id="' +
                headers2["visitid"] +
                '">' +
                name +
                "</a></td></tr>";
              $(".table").append(div);
              // console.log(allNames)
            })
            .catch((error) => {
              console.log(error);
            });
        }
        //
        //
        // allstring += '</table></div>';
        // if(allNames.length == localStorage.getItem('verifiedlength'))
        // {

        //     for(var j=0;j<allNames.length;j++)
        //     {
        //         allstring += '<tr><td><a className="checkPatientDetails" id="">' + allNames[j] + '</a></td></tr>';
        //         console.log(allNames[j])
        //     }
        //     $('#appended').html(allstring);
        //     // console.log(allNames)
        // }

        // console.log(allstring)
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    // Complications = request.json["Complications"],
    // PregnancyDate = request.json["PregnancyDate"],
    // EvolutionAndTreatment = request.json["EvolutionAndTreatment"],

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { allModuleData, visible } = this.state;

    let { DataLoaded } = this.state;

    const menstrual_data = this.menstrual_data;

    return (
      <div>
        <Headers />

        <InterModularSidebar />
        <main className="content-container ">
          <div className="container p-2">
            <form>
              <div className="form-row pt-4 allDataForm">
                <div
                  className={visible}
                  style={{ width: "100%" }}
                  id="appended"
                ></div>
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="row">
                  <div className="table-responsive">
                    <table className="table">
                      <tr>
                        <th>All Active Visits</th>
                      </tr>
                    </table>
                  </div>
                </div>
                {/* {allModuleData.map(d => 
                    (<li >{d}</li>
                    ))}  */}
                {/* <MDBDataTable striped bordered data={menstrual_data} /><br/> */}

                {/* <h1  className="text-capitalize" style={font16}>Antenatal History</h1>
                 <MDBDataTable striped bordered data={antenatal_data} />
                <p className="text-capitalize" style={font16}>Obstetric History</p>
                 <MDBDataTable striped bordered data={obstetrichistory_data} />
                 <p className="text-capitalize" style={font16}>Pregnancy History</p>
                 <MDBDataTable striped bordered data={pregancyhistorydata} />
                 <p className="text-capitalize" style={font16}>Obstetric Ultra-sound</p>
                 <MDBDataTable striped bordered data={obsounddata} />
                 <p className="text-capitalize" style={font16}>Pre-plan Data</p>
                 <MDBDataTable striped bordered data={preplandata} />
                 <p className="text-capitalize" style={font16}>Complications Data</p>
                 <MDBDataTable striped bordered data={complicationdata} />
                 <p className="text-capitalize" style={font16}>Utilization Of Drugs Data</p>
                 <MDBDataTable striped bordered data={utilizationData} /> */}
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default AllActivePatients;
